import { SelectOption } from 'utils';

export const makeDomainsOptions =
    ({ value = 'id', label = 'name' }: { value?: string; label?: string } = {}) =>
    (data: any) =>
        ({
            label: data[label],
            value: data[value],
        } as SelectOption);
